// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, type Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  constructor(
    private readonly http: HttpClient,
    private readonly utilS: UtilService,
  ) {}

  encrypt(username: string, password: string): Observable<any> {
    const url = environment.AuthUrl() + '/encryption/encrypt';
    const encryptString = {
      UserName: username,
      Password: password,
    };
    const data = {
      plainText: JSON.stringify(encryptString),
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        ClientId: environment.ClientId,
      }),
    };

    return this.http.post(url, data, httpOptions).pipe(
      catchError((error) => {
        this.utilS.consoleGroup('Encryption error:', error);
        throw error;
      }),
    );
  }

  encryptValue(value: string): Observable<any> {
    const url = environment.AuthUrl() + '/encryption/encrypt';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        ClientId: environment.ClientId,
      }),
    };
    const data = {
      plainText: JSON.stringify(value),
    };

    return this.http.post(url, data, httpOptions).pipe(
      catchError((error) => {
        this.utilS.consoleGroup('Encryption error:', error);
        throw error;
      }),
    );
  }

  decrypt(encryptedText: string, userName: string): Observable<any> {
    const url = environment.AuthUrl() + '/encryption/decrypt';
    const data = {
      encryptedText,
      userName,
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        ClientId: environment.ClientId,
      }),
    };

    return this.http.post(url, data, httpOptions).pipe(
      catchError((error) => {
        this.utilS.consoleGroup('Decryption error:', error);
        throw error;
      }),
    );
  }
}
